export default "__VITE_ASSET__8DgHAyTp__"